import store from "@/store";
import { mapError } from "@/utils/ObservableUtils";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelTokenSource } from "axios";
import download from "downloadjs";
import { from, Observable } from "rxjs";

class Service {

  private client: AxiosInstance;

  private cancelTokens = new Map<string, CancelTokenSource>();

  constructor() {
    this.client = axios.create();
  }

  public get(path: string, config?: AxiosRequestConfig): Observable<AxiosResponse> {
    const request = this.client.get(path, config);
    return from(request).pipe(mapError());
  }

  public post(path: string, data: object, config?: AxiosRequestConfig): Observable<AxiosResponse> {
    const options = {
      headers: {"Content-Type": "text/json"}
    };
    const request = this.client.post(path, data, {...options, ...config});
    return from(request).pipe(mapError());
  }

  public put(path: string, data?: object): Observable<AxiosResponse> {
    const request = this.client.put(path, data);
    return from(request).pipe(mapError());
  }

  public patch(path: string, data?: object): Observable<AxiosResponse> {
    const request = this.client.patch(path, data);
    return from(request).pipe(mapError());
  }

  public delete(path: string, data: object): Observable<AxiosResponse> {
    const request = this.client.delete(path, data);
    return from(request).pipe(mapError());
  }

  public cancellableGet(path: string, params: URLSearchParams, headers: object = {}): Observable<AxiosResponse> {
    if (this.cancelTokens.has(path)) {
      // @ts-ignore
      this.cancelTokens.get(path).cancel();
    }
    this.cancelTokens.set(path, axios.CancelToken.source());
    // @ts-ignore
    const request = this.client.get(path, { params, cancelToken: this.cancelTokens.get(path).token, headers});
    // @ts-ignore
    return from(request);
  }

  public getFile(path: string, username: string): void {
    axios
      .get(path, {
        responseType: "blob"
      })
      .then((response) => {
        const content = response.headers["content-type"];
        download(response.data, `genome_${username}`, content);
      });
  }

}

export const OpportunitiesApiService = new Service();
